// let API_CONST = '';

// if (location.origin.includes('dashboard.neuapix'))
// 	API_CONST = 'https://api.neuapix.com';
// else if (location.origin.includes('dashboard-staging.neuapix'))
// 	API_CONST = 'https://api-staging.neuapix.com';
// else if (location.origin.includes('dashboard-qa.adlsandbox'))
// 	API_CONST = 'https://apibsp-qa.adlsandbox.net';
// else if (location.origin.includes('demo-dev.adlsandbox.net'))
// 	API_CONST = 'https://apibsp-dev.adlsandbox.net';
// else API_CONST = 'https://apibsp-dev.adlsandbox.net';

// export const environment = {
// 	production: false,
// 	api: API_CONST,
// };
let API_CONST = '';
const origin = location.origin;

// 1. Cek Production
if (origin.includes('dashboard.neuapix.com')) {
    API_CONST = 'https://api.neuapix.com';
}
// 2. Cek Staging
else if (origin.includes('dashboard-staging')) {
    API_CONST = 'https://api-staging.neuapix.com';
}
// 3. Cek QA
else if (origin.includes('dashboard-qa')) {
    API_CONST = 'https://apibsp-qa.adlsandbox.net';
}
// 4. Cek Demo Dev secara spesifik
else if (origin.includes('demo-dev')) {
    API_CONST = 'https://apibsp-dev.adlsandbox.net';
}
// 5. Default (Localhost atau lainnya)
else {
    API_CONST = 'https://apibsp-dev.adlsandbox.net';
}

export const environment = {
    production: false,
    api: API_CONST,
};
